import BaseModel from '../core/BaseModel'
export default class EvaluationFormDangerModel extends BaseModel {
    constructor() {
        super({
            tableName: 'evaluation_form_danger', label: "Đánh giá rủi ro", display_key: 'name',name: "evaluation_form_danger",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              class: 'center width_150 common',
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            situation_name: { 
              name: 'situation_name', 
              type: "TEXT", 
              label: 'Tình huống',
              filter: { type: "input", match: "contains" },
            },
            danger_name: { 
              name: 'danger_name', 
              type: "TEXT", 
              label: 'Mối nguy',
              filter: { type: "input", match: "contains" },
            },
            point_rb: { 
              name: 'point_rb', 
              type: "CustomPopup", 
              label: 'R(b)', 
            },
            code_rb: { 
              name: 'code_rb', 
              type: "CustomUrl", 
              label: 'Mức độ (b)', 
            },
            point_re: { 
              name: 'point_re', 
              type: "CustomPopup", 
              label: 'R(e)', 
            },
            code_re: { 
              name: 'code_re', 
              type: "CustomUrl", 
              label: 'Mức độ (e)', 
            },
            point_ra: { 
              name: 'point_ra', 
              type: "CustomPopup", 
              label: 'R(a)',
            },
            code_ra: { 
              name: 'code_ra', 
              type: "CustomUrl", 
              label: 'Mức độ (a)', 
            },
            bpks_text: { 
              name: 'bpks_text', 
              type: "CustomPopup", 
              label: 'BPKS', 
            },
            updated_name: {
              renamefs:"updated_name",
              type: "String",
              label: "Người cập nhật"
            },
            updated_at : {
              name: 'updated_at',
              type: "Datetime",
              label: 'Ngày cập nhật',
            },
        })
    }

}